import { domStorage, viewStorage } from '../_globals'
import gsap from 'gsap'

export default class ConfigPopup {
  constructor() {
    if (!domStorage.configPopup) return

    this.DOM = {
      inner: domStorage.configPopup.querySelector('.ConfigPopup__inner'),
      closeButton: domStorage.configPopup.querySelector('.ConfigPopup__inner__close'),
      visual: domStorage.configPopup.querySelector('.ConfigPopup__inner__visual'),
    }

    console.log(domStorage.configPopup)

    this.setEvents()
  }

  setEvents() {
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)

    // Open the popup after 1sec
    setTimeout(() => this.open(), 1000)

    this.DOM.closeButton.addEventListener('click', this.close)
  }

  open() {
    this.timelineIn = gsap.timeline({
      default: {
        ease: 'expo.out',
        duration: 0.75
      },
      onStart: () => {
        document.body.style.overflow = 'hidden'
        domStorage.configPopup.style.pointerEvents = 'all'

        if (viewStorage.viewScroll.scroll) {
          viewStorage.viewScroll.scroll.stop()
        }
      }
    })

    this.timelineIn.fromTo(domStorage.configPopup, {
      opacity: 0
    }, {
      opacity: 1,
    }, 0)

    this.timelineIn.fromTo(this.DOM.inner, {
      yPercent: 100,
      scale: 0.4,
      rotate: gsap.utils.random(-12, 12),
      opacity: 0
    }, {
      yPercent: 0,
      scale: 1,
      rotate: 0,
      opacity: 1,
      ease: "elastic.out(1,0.95)",
      duration: 1
    }, 0.5)

    if (this.DOM.visual) {
      this.timelineIn.fromTo(this.DOM.visual, {
        rotate: gsap.utils.random(-6, 6),
        scale: 0.5,
        yPercent: 150,
        opacity: 0
      }, {
        rotate: gsap.utils.random(-6, 6),
        scale: 1,
        yPercent: 0,
        opacity: 1,
        ease: 'power3.inOut',
        duration: 1
      }, 0.5)
    }

    return this.timelineIn
  }

  close(event) {
    event.preventDefault()

    this.timelineOut = gsap.timeline({
      defaults: {
        ease: 'expo.out',
        duration: 0.75
      },
      onStart: () => {
        domStorage.configPopup.style.pointerEvents = ''
      },
      onComplete: () => {
        if (viewStorage.viewScroll.scroll) {
          viewStorage.viewScroll.scroll.start()
        }

        document.body.style.overflow = ''

        this.destroy()
      }
    })

    this.timelineOut.to(domStorage.configPopup, {
      opacity: 0,
    }, 0)

    return this.timelineOut
  }

  destroy() {
    this.timelineIn.kill()
    this.timelineOut.kill()
    domStorage.configPopup.remove()
  }
}